export default __webpack_public_path__ + "static/group-insights-light-mode-8768419c9e53f81bbf255a62054e8469.png";